import { AlertTriangle, Trash2 } from 'lucide-react'

import { Button } from '@/shared/components/ui/button'
import { Dialog, DialogContent } from '@/shared/components/ui/dialog'

export default function QuoteDeleteConfirmDialog({
  open,
  onOpenChange,
  quote,
  onConfirm,
  isDeleting = false,
}) {
  if (!quote) return null

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[calc(100vw-1.5rem)] max-w-[400px] rounded-2xl sm:rounded-[24px] border-0 p-4 sm:p-6 shadow-2xl [&>button]:hidden">
        <div className="flex flex-col items-center gap-4 text-center">
          <div className="flex size-14 items-center justify-center rounded-full bg-red-50">
            <AlertTriangle className="size-7 text-red-500" />
          </div>

          <div>
            <h2 className="text-base sm:text-[17px] font-bold text-slate-900">
              Delete Quotation?
            </h2>
            <p className="mt-1.5 text-sm text-slate-500">
              Are you sure you want to delete{' '}
              <span className="font-semibold text-slate-700">
                {quote.quoteNo}
              </span>
              ? This action cannot be undone.
            </p>
          </div>

          <div className="flex flex-col-reverse sm:flex-row w-full gap-2.5 sm:gap-3">
            <Button
              type="button"
              variant="outline"
              className="w-full sm:flex-1 rounded-xl"
              onClick={() => onOpenChange(false)}
              disabled={isDeleting}
            >
              Cancel
            </Button>

            <Button
              type="button"
              className="w-full sm:flex-1 rounded-xl bg-red-500 text-white hover:bg-red-600"
              onClick={onConfirm}
              disabled={isDeleting}
            >
              <Trash2 className="mr-2 size-4" />
              {isDeleting ? 'Deleting...' : 'Delete'}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
